export const setLoginStatus = (errorCode) => {
    switch (errorCode) {
        case "auth/invalid-email":
            return "Wrong email form.";
        case "auth/user-not-found":
            return "This email doesn't exist in our database.";
        case "auth/wrong-password":
            return "Wrong password.";
        case "auth/user-disabled":
            return "This account is disabled.";
        case "auth/account-exists-with-different-credential":
            return "This email already exist in our database.";
        case "other/success":
            return "Logged successfully";
        default:
            return errorCode;
    }
}

export const setRegisterStatus = (errorCode) => {
    switch (errorCode) {
        case "auth/invalid-email":
            return "Wrong email form.";
        case "auth/email-already-in-use":
            return "This email is already in use.";
        case "auth/operation-not-allowed":
            return "Operation not allowed.";
        case "auth/weak-password":
            return "Password is too weak.";
        case "other/different-passwords":
            return "Passwords don't match.";
        case "other/too-short-username":
            return "Username is too short."
        case "other/success":
            return "Account created successufully. You can log in now.";
        default:
            return "Unknown error";
    }
}

export const setPasswordChangeStatus = (errorCode) => {
    switch (errorCode) {
        case "auth/operation-not-allowed":
            return "Operation not allowed.";
        case "auth/weak-password":
            return "Password is too weak.";
        case "other/different-passwords":
            return "Passwords don't match.";
        case "other/success":
            return "Password successfully changed";
        default:
            return "Unknown error";
    }
}

export const setReAuthStatus = (errorCode) => {
    switch (errorCode) {
        case "auth/wrong-password":
            return "Wrong password.";
        default:
            return "Unknown error";
    }
}

export const setUsernameChangeStatus = (errorCode) => {
    switch (errorCode) {
        case "other/success":
            ///updateUsernameInMenu();
            return "Username changed successfully.";
        default:
            return "Unknown error";
    }
}

export const setEmailChangeStatus = (errorCode) => {
    switch (errorCode) {
        case "auth/invalid-email":
            return "Wrong email form.";
        case "auth/email-already-in-use":
            return "This email is already in use.";
        case "other/success":
            return "Email changed successfully";
        default:
            return "Unknown error";
    }
}

export const setPictureChangeStatus = (errorCode) => {
    switch (errorCode) {
        case "other/uploading-started":
            return "Uploading...";
        case "other/uploading-finished":
            return "Uploading finished.";
        case "other/success":
            return "Profile picture changed successfully.";
        default:
            return "Unknown error";
    }
}